module.exports = __webpack_public_path__ + "static/media/revisions.320cb2a6.svg";